import { signInAnonymously } from 'firebase/auth'
import { doc, getDoc } from 'firebase/firestore'

export const STARTUP_DOC = ['gate1', 'startup']

// The launch path the war screen waits for: anonymous sign-in, then one
// Firestore read. Each step is timed; a failed step is recorded, not thrown,
// so the war screen still comes up and the log says what went wrong.
export async function runStartup({ auth, db, mark }) {
    const out = { authSource: null, uid: null, doc: null, errors: [] }

    try {
        await auth.authStateReady()
        mark('authStateReady')
        const persisted = !!auth.currentUser
        const cred = await signInAnonymously(auth)
        out.authSource = persisted ? 'persisted' : 'signIn'
        out.uid = cred.user.uid
    } catch (e) {
        out.errors.push({ step: 'auth', code: e.code ?? null, message: String(e.message ?? e) })
    }
    mark('authDone')

    try {
        const snap = await getDoc(doc(db, ...STARTUP_DOC))
        out.doc = {
            path: STARTUP_DOC.join('/'),
            exists: snap.exists(),
            fromCache: snap.metadata.fromCache,
            source: snap.metadata.fromCache ? 'cache' : 'server',
        }
    } catch (e) {
        out.doc = { path: STARTUP_DOC.join('/'), exists: null, fromCache: null, source: null }
        out.errors.push({ step: 'docRead', code: e.code ?? null, message: String(e.message ?? e) })
    }
    mark('docRead')

    return out
}
